<template>
  <div class="content-body">
    <LanguageSelector />
    <Alert v-if="error == 'error-message'" :text="errorText" type="danger" dismissable="false" />
    <section id="basic-datatable">
      <div class="row">
        <div class="col-12">
          <div class="text-right">
            <button type="button" class="btn btn-primary mb-1" @click="inviteUserModal()">
              <em class="bx bx-envelope"></em>
              <span class="align-middle ml-25">{{ $t('Invite User') }}</span>
            </button>
          </div>
          <div class="card">
            <div class="card-content">
              <div class="card-header">
                <h5 class="card-title">{{ $t('Manage Invites') }}</h5>
                <div class="heading-elements">
                  <ul class="list-inline mb-0">
                    <li class="liStyling">
                      <legend class="has-icon-left">
                        <select class="form-control" v-model="typeFilter" @change="filterByType(typeFilter)">
                          <option selected>{{ $t('All Types...') }}</option>
                          <option value="tenant">{{ $t('Tenants') }}</option>
                          <option value="landlord">{{ $t('Landlords') }}</option>
                        </select>
                        <div class="form-control-position">
                          <em class="bx bx-filter font-medium-1"></em>
                        </div>
                      </legend>
                    </li>
                    <li>
                      <legend class="has-icon-left">
                        <input type="text" class="form-control" @keyup="searchInTable()" v-model="searchInputText"
                          :placeholder="$t('Search...')" />
                        <div class="form-control-position">
                          <em class="bx bx-search font-medium-1"></em>
                        </div>
                      </legend>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card-body card-dashboard">
                <div class="text-center">
                  <div class="spinner-border text-primary" role="status" v-if="loadingData" style="opacity: .6">
                    <span class="sr-only">{{ $t('Loading...') }}</span>
                  </div>
                </div>
                <div class="text-center mt-1" v-if="!invites.length && !loadingData">
                  <p>{{ $t('No Invites Found...') }}</p>
                </div>
                <div class="table-responsive" v-if="invites.length">
                  <table class="table zero-configuration" aria-describedby="invited users list">
                    <thead>
                      <tr>
                        <th>{{ $t('Name') }}</th>
                        <th>{{ $t('Phone Number') }}</th>
                        <th>{{ $t('Email') }}</th>
                        <th>{{ $t('Type of user') }}</th>
                        <th>{{ $t('Date of invitation') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(invite, index) in invites" :key="index">
                        <td class="inviteName">
                          <span class="nameSpan" v-if="invite.name">{{ invite.name }}</span>
                          <span class="nameSpan" v-else>-</span>
                          <br />
                          <a href="#" style="margin-top: 5px;" @click="deleteInvite(invite.uid)">
                            <em class="bx bx-trash"></em> {{ $t('Delete') }}
                          </a>
                        </td>
                        <td v-if="invite.phoneNumber">{{ invite.phoneNumber }}</td>
                        <td v-else>-</td>
                        <td v-if="invite.email">{{ invite.email }}</td>
                        <td v-else>-</td>
                        <td class="capitalize">{{ invite.type }}</td>
                        <td>{{ invite.createdAt.split('T')[0] }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Invite User -->
    <div class="modal fade text-left" id="invite-user-modal" tabindex="-1" role="dialog"
      aria-labelledby="create-modal-title" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="create-modal-title">{{ $t('Invite User') }}</h3>
            <button type="button" class="close rounded-pill" data-dismiss="modal" aria-label="Close">
              <em class="bx bx-x"></em>
            </button>
          </div>
          <div class="modal-body">
            <Alert v-if="error == 'required'" :text="$t('Phone or email validation')" type="danger"
              dismissable="false" />
            <Alert v-if="error == 'error-message'" :text="errorText" type="danger" dismissable="false" />
            <form action="#">
              <div class="form-group row">
                <div class="col-md-12 col-sm-12">
                  <label for>{{ $t('Name') }}</label>
                  <input type="text" class="form-control" :placeholder="$t('John Doe')" v-model="nameInvite" />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-12 col-sm-12">
                  <label for>{{ $t('Country') }}</label>
                  <select v-model="countryInvite" class="form-control">
                    <option value="Choose..." selected disabled>{{ $t('Choose...') }}</option>
                    <option v-for="(country, index) in activeCountries" :key="index" :value="country.toLowerCase()">{{
    countryName(country)
}}</option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-12 col-sm-12">
                  <label for>{{ $t('Language') }}</label>
                  <select class="form-control" v-model="languageInvite">
                    <option value="en">{{ $t('English') }}</option>
                    <option value="ar">{{ $t('Arabic') }}</option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-12 col-sm-12">
                  <label for>{{ $t('Type') }}</label>
                  <select class="form-control" v-model="typeInvite">
                    <option value="landlord">{{ $t('Landlord') }}</option>
                    <option value="tenant">{{ $t('Tenant') }}</option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-6 col-sm-12">
                  <label for>{{ $t('Email') }}</label>
                  <input type="text" class="form-control" :placeholder="$t('johndoe@example.com')"
                    v-model="emailInvite" />
                </div>
                <div class="col-md-6 col-sm-12">
                  <label for>{{ $t('Phone Number') }}</label>
                  <input type="tel" id="phoneNumber" class="form-control" v-model="invitePhoneNumber" />
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light-secondary" data-dismiss="modal">
              <em class="bx bx-x d-block d-sm-none"></em>
              <span class="d-none d-sm-block">{{ $t('Close') }}</span>
            </button>
            <button type="button" class="btn btn-primary ml-1" @click="sendInvitation()">
              <em class="bx bx-check d-block d-sm-none"></em>
              <span class="d-none d-sm-block">{{ $t('Send Invitation') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/app-assets/js/scripts/extensions/ext-component-block-ui.js";
import { getCountryName } from "@/app-assets/js/get-countries.js";
import { getLanguageName } from "@/app-assets/js/get-language.js";
import Alert from "@/components/Alerts";
export default {
  data() {
    return {
      invites: [],
      loadingData: true,
      usersCountries: [],
      countryFilter: "All Countries...",
      typeFilter: "All Types...",
      activeCountries: [],
      searchInputText: "",
      phoneNumberObj: null,
      invitePhoneNumber: "",
      nameInvite: "",
      emailInvite: "",
      countryInvite: "Choose...",
      languageInvite: "en",
      typeInvite: "landlord",
      error: "",
      errorText: "",
    };
  },

  components: {
    Alert
  },

  computed: {
    isSuperadmin() {
      return this.$store.state.currentUser.user.type === "superadmin";
    }
  },

  methods: {
    initDataTable() {
      setTimeout(function () {
        $(".zero-configuration").DataTable({
          bLengthChange: false,
          bFilter: false,
          order: []
        });
      }, 100);
    },

    getInvites() {
      let self = this;
      self.loadingData = true;
      this.$apiCall.get("/v1/invites").then(response => {
        response.data.data.forEach(function (element) {
          if (
            !self.usersCountries.includes(element.country) &&
            element.country
          ) {
            self.usersCountries.push(element.country);
          }
        });
        self.loadingData = false;
        self.invites = response.data.data;
        self.initDataTable();
      });
    },

    countryName(element) {
      if (element) {
        return getCountryName(element.toUpperCase());
      }
    },

    langName(element) {
      if (element) {
        return getLanguageName(element);
      }
    },

    getActiveCountries() {
      const countries = localStorage.getItem('activeCountries');
      this.activeCountries = (countries && countries != '') ? countries.split(',') : ["LB", "JO"];
    },

    searchInTable() {
      let value = this.searchInputText.toLowerCase();
      $(".zero-configuration > tbody tr").filter(function () {
        $(this).toggle(
          $(this)
            .find(".inviteName > .nameSpan")
            .text()
            .toLowerCase()
            .indexOf(value) > -1
        );
      });
    },

    filterByCountry(country) {
      let self = this;
      if (country != "All Countries...") {
        self.loadingData = true;
        self.invites = [];
        self.$apiCall
          .get(`/v1/invites?country=${country}`)
          .then(response => {
            self.loadingData = false;
            self.invites = response.data.data;
            self.initDataTable();
          });
      } else {
        self.invites = [];
        self.usersCountries = [];
        self.getInvites();
      }
    },

    filterByType(type) {
      let self = this;
      if (type != "All Types...") {
        self.loadingData = true;
        self.invites = [];
        self.$apiCall
          .get(`/v1/invites?type=${type}`)
          .then(response => {
            self.loadingData = false;
            self.invites = response.data.data;
            self.initDataTable();
          });
      } else {
        self.invites = [];
        self.usersCountries = [];
        self.getInvites();
      }
    },

    initTelInput() {
      let input = document.querySelector("#phoneNumber");
      this.phoneNumberObj = intlTelInput(input);
    },

    inviteUserModal() {
      $("#invite-user-modal").modal();
    },

    sendInvitation() {
      let self = this;
      this.error = "";
      this.errorText = "";

      let countryData = this.phoneNumberObj.getSelectedCountryData();
      let pN = "+" + countryData.dialCode + this.invitePhoneNumber.replace(`+${countryData.dialCode}`, "");
      if (self.invitePhoneNumber != "" || self.emailInvite != "") {
        let block_ele = $("#invite-user-modal .modal-content");
        $(block_ele).block({
          message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
          overlayCSS: {
            backgroundColor: "#fff",
            opacity: 0.8,
            cursor: "wait"
          },
          css: {
            border: 0,
            padding: 0,
            backgroundColor: "transparent"
          }
        });
        this.$apiCall
          .post("/v1/invites", {
            email: (self.emailInvite.trim() != "") ? self.emailInvite : null,
            name: self.nameInvite,
            phoneNumber: (self.invitePhoneNumber != "") ? pN : null,
            language: self.languageInvite,
            type: self.typeInvite,
            country: self.countryInvite
          })
          .then(response => {
            $(block_ele).unblock();
            self.invitePhoneNumber = "";
            self.nameInvite = "";
            self.emailInvite = "";
            self.languageInvite = "en";
            self.countryInvite = "Choose...";
            self.typeInvite = "landlord";
            $("#invite-user-modal").modal("hide");
            self.invites = [];
            self.getInvites();
          })
          .catch(error => {

            if (error.response.status == 406) {
              self.error = "error-message";
              self.errorText = `$t('Invitation already exists')`;
            } else if (error.response.status == 405) {
              self.error = "error-message";
              self.errorText = `$t('User already exists ')`;
            } else {
              self.error = "error-message";
              self.errorText = `$t('Ops') ${error.response.data.message}`;
            }

            $(block_ele).unblock();
          })
      } else {
        self.error = 'required';
      }
    },

    deleteInvite(uid) {
      this.error = ''
      this.errorText = ''
      let self = this;
      $.blockUI({
        message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
        overlayCSS: {
          backgroundColor: "#fff",
          opacity: 0.8,
          cursor: "wait"
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: "transparent"
        }
      });

      this.$apiCall.delete(`/v1/invites/${uid}`).then(() => {
        $.unblockUI();
        self.invites = [];
        self.getInvites();
      })
        .catch(error => {
          $.unblockUI();
          this.error = "error-message";
          this.errorText = `$t('Ops') ${error.response.data.message}`;
          $("html, body").animate(
            {
              scrollTop: $("body").offset().top,
            },
            500
          );
        })
    }
  },

  watch: {
    invitePhoneNumber: function (value) {
      this.invitePhoneNumber = value.replace(/[^\d|\-+]/g, '')
    }
  },

  mounted() {
    this.initTelInput();
    this.getInvites();
    this.getActiveCountries();
    this.countryInvite = "Choose...";
  }
};
</script>

<style scoped>
.zero-configuration td {
  white-space: nowrap;
}

.liStyling {
  margin-right: 1em;
}
</style>